import styled from 'styled-components';
import { CameraOutlineIc } from '@dsch/dd-icons';

import { ButtonLink } from '../../../../../components/Toolkit/Button/ButtonLink';
import { media } from 'helpers/breakpoints';

export interface GalleryPlaceholderProps {
  buttonLink: string;
  isViewingOwnAd: boolean;
  className?: string;
}

const NoPhotoSectionWrapper = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  display: flex;
  height: 100%;
  justify-content: center;
`;

const Camera = styled(CameraOutlineIc)`
  color: ${({ theme }) => theme.colors.GREY_LIGHT};
  display: block;
  height: 80px;
  margin: 0 auto;
  width: 80px;

  ${media.large} {
    height: 160px;
    width: 160px;
  }
`;

const Container = styled.div`
  display: grid;
  justify-items: center;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
`;

const CameraContainer = styled.div`
  width: 80px;
  height: 80px;
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  ${media.large} {
    width: 160px;
    height: 160px;
  }
`;

/*
 * Accepts optional boolean isViewingOwnAd.
 * The spacing between the main text and button is great then space when no button is needed.
 */

const SGalleryMainText = styled.p<{ isViewingOwnAd?: boolean }>`
  ${({ theme }) => theme.fontSize.L18};
  color: ${({ theme }) => theme.colors.GREY};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme, isViewingOwnAd }) =>
    isViewingOwnAd ? theme.spacing.M16 : theme.spacing.S8};
  text-align: center;

  ${media.large} {
    ${({ theme }) => theme.fontSize.L24};
    margin-bottom: ${({ theme, isViewingOwnAd }) =>
      isViewingOwnAd ? theme.spacing.M24 : theme.spacing.S8};
  }
`;

const SGallerySubText = styled.p`
  ${({ theme }) => theme.fontSize.M14};
  text-align: center;
`;

const SButtonLink = styled(ButtonLink)`
  width: 202px;
`;

function GalleryPlaceholder({
  buttonLink,
  isViewingOwnAd,
  className,
}: GalleryPlaceholderProps) {
  return (
    <NoPhotoSectionWrapper className={className}>
      <Container>
        <CameraContainer>
          <Camera width="80" height="80" />
        </CameraContainer>

        {isViewingOwnAd ? (
          <>
            <SGalleryMainText isViewingOwnAd={isViewingOwnAd}>
              Add Photos, Sell 2X Faster
            </SGalleryMainText>
            <SButtonLink
              href={buttonLink}
              data-tracking="add-photo-no-image"
              ofType="SECONDARY"
            >
              Add Photos
            </SButtonLink>
          </>
        ) : (
          <>
            <SGalleryMainText>No images to show</SGalleryMainText>
            <SGallerySubText>
              The seller has not uploaded any images
            </SGallerySubText>
          </>
        )}
      </Container>
    </NoPhotoSectionWrapper>
  );
}

export { GalleryPlaceholder };
